/*
The git blame for the ComponentStates below should take you
to the PR and linked JIRA ticket that introduced the concept of
UiRestrictions and ComponentStates.

In short, certain marketplaces will provide pre-purchased/pre-configured
labels with the orders. For these orders — fulfillmentPlans — we do not want
users to have the same flexibility of fulfillmentPlan configuration that is
offered to configurable orders. To accommodate this, WebV3Api sends a list of
restrictions that correspond to UI components which should be restricted in some way.

The UiRestrictions enum contains the list of possible restricted components.
The ComponentStates enum contains the possible ways these can be restricted.

** Note: These are not exhaustive enums. **
(Please delete ^ once the enums do contain all knowns values)
*/

export const UiRestrictions = {
  AmountSummary: 'amountSummary',
  HoldUntilDate: 'holdUntilDateTime',
  IsGift: 'isGift',
  LabelConfiguration: 'labelConfiguration',
  RecipientTaxIndentifier: 'recipientTaxIdentifier',
  ShipByDate: 'shipByDateTime',
  ShipTos: 'shipTos',
  DeliverByDate: 'deliverByDateTime',
};

const ComponentStates = {
  Disabled: 'Disabled',
  Hidden: 'Hidden',
  PrintOnly: 'PrintOnly',
  Provided: 'Provided',
  ReadOnly: 'ReadOnly',
};

export default ComponentStates;
